import { createSlice } from "@reduxjs/toolkit";

import { toGetReturnChange } from "../actions/return.actions";

const initialState = {
  returnChange: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const returnChangeSlice = createSlice({
  name: "returnChange",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetReturnChange.pending, (state) => {
      state.returnChange = { list: [], status: "idle" };
    });
    builder.addCase(toGetReturnChange.fulfilled, (state, action) => {
      state.returnChange = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetReturnChange.rejected, (state, action) => {
      state.returnChange = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default returnChangeSlice.reducer;
